/**
 * Custom hook for Intersection Observer
 * Used to track which section is currently visible
 */

import { useEffect, useState, useRef } from 'react';

export const useIntersectionObserver = (options = {}) => {
  const [activeSection, setActiveSection] = useState('');
  const observerRef = useRef(null);

  useEffect(() => {
    const defaultOptions = {
      root: null,
      rootMargin: '-50% 0px -50% 0px',
      threshold: 0,
      ...options,
    };

    observerRef.current = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    }, defaultOptions);

    // Observe all sections
    const sections = document.querySelectorAll('section[id]');
    sections.forEach((section) => {
      observerRef.current.observe(section);
    });

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  return activeSection;
};

export default useIntersectionObserver;
